module.exports = __webpack_public_path__ + "static/media/2011_Population_totalRate.b430e21e.png";